export const CTA_TEXT = "See if my furniture qualifies";

export const scrollToQualify = () => {
  document.getElementById("qualify")?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Kicker = ({ children, light }) => (
  <p className={`text-[11px] uppercase tracking-[0.3em] font-bold mb-5 ${light ? "text-[#c19a6b]" : "text-[#c19a6b]"}`}>{children}</p>
);

export const CtaButton = ({ testId, className = "", onClick = scrollToQualify, children = CTA_TEXT, type = "button", disabled }) => (
  <button
    type={type}
    data-testid={testId}
    onClick={onClick}
    disabled={disabled}
    className={`inline-flex items-center justify-center h-14 px-8 sm:px-10 bg-black text-white text-[12px] sm:text-[13px] uppercase tracking-[0.22em] font-bold btn-lift disabled:opacity-60 disabled:hover:transform-none ${className}`}
  >
    {children}
  </button>
);

export const OptionButton = ({ selected, onClick, children, testId, className = "" }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    aria-pressed={selected}
    className={`min-h-[56px] px-4 py-3 text-left text-[15px] leading-snug border transition-colors duration-150 ${
      selected ? "bg-black text-white border-black" : "bg-white text-black border-gray-300 hover:border-black"
    } ${className}`}
  >
    {children}
  </button>
);
